import styled from 'styled-components'

export const StarScore = styled.div`
  display: flex;
  justify-content: space-between;
`
